import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import '../styles/infosku.css';
import { useNavigate } from 'react-router-dom';
import { jsPDF } from 'jspdf';
import JsBarcode from 'jsbarcode';

import { API_BASE } from '../config';
const InfoSku = () => {
  const { token } = useAuth(); // Accede al token desde el contexto de autenticación
  const [sku, setSku] = useState(''); // Estado para el SKU
  const [quantity, setQuantity] = useState(''); // Estado para la cantidad por pallet
  const [expiryDate, setExpiryDate] = useState(''); // Estado para la fecha de vencimiento
  const [loading, setLoading] = useState(false); // Estado para mostrar el estado de carga
  const [error, setError] = useState(null); // Estado para manejar errores
  const navigate = useNavigate();

  const generateBarcode = (barcode) => {
    const canvas = document.createElement('canvas');
  
    // Si el código tiene menos de 12 caracteres, generamos un código de barras tipo CODE128
    if (barcode.length < 12) {
      JsBarcode(canvas, barcode, { format: 'CODE128', displayValue: true });
    } else {
      // Si el código tiene 12 o más caracteres, generamos un código de barras tipo EAN13
      JsBarcode(canvas, barcode, { format: 'EAN13', displayValue: true });
    }
  
    return canvas.toDataURL('image/png');
  };
  
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError(null);
  
    try {
      // Realiza la solicitud al endpoint
      const response = await fetch(
        `${API_BASE}/get-sku-info?sku_code=${sku}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${token}`, // Enviar el token en el header
          },
        }
      );
  
      if (!response.ok) {
        throw new Error('Error al obtener información del SKU');
      }
  
      const data = await response.json();
  
      // Verificar el código de barras recibido
      console.log('Código de barras recibido:', data.sku_barcode);
  
      // Validar si la información recibida del API es correcta
      if (!data || !data.sku_name || !data.sku_barcode) {
        throw new Error('La respuesta del servidor no contiene datos válidos');
      }
  
      // Validar si el código de barras es válido
      if (data.sku_barcode) {
        // Generar código de barras según la longitud
        const barcodeImage = generateBarcode(data.sku_barcode);
      
        // Crear un documento PDF usando jsPDF
        const doc = new jsPDF();
      
        // Añadir el logo a la parte superior izquierda del PDF
        const logoUrl = 'https://cdn.prod.website-files.com/62dec1bd16ef6f316a9bbad3/62dec3b0c28a4ef376e5beee_loken_isotipo_no_bg.png';
        const logoWidth = 20; // Ancho del logo
        const logoHeight = 20; // Alto del logo
        doc.addImage(logoUrl, 'PNG', 10, 10, logoWidth, logoHeight);
      
        // Título principal centrado
        doc.setFontSize(18);
        doc.setFont('helvetica', 'bold'); // Fuente en negrita
        doc.text('Información de SKU', 105, 30, { align: 'center' });
      
        // Línea separadora
        doc.setDrawColor(0, 0, 0); // Color negro
        doc.line(10, 40, 200, 40); // Línea horizontal
      
        // Añadir los datos organizados con títulos y valores
        doc.setFontSize(12);
      
        // Títulos de los datos
        const labels = [
          'Cantidad por pallet:',
          'SKU:',
          'Fecha de vencimiento:',
          'Nombre del producto:',
          'Código de barras:',
        ];
        const values = [
          `${quantity || 'No especificada'} unidades/kg`,
          `${sku || 'No disponible'}`,
          `${expiryDate || 'No especificada'}`,
          `${data.sku_name || 'No disponible'}`,
          `${data.sku_barcode || 'No disponible'}`,
        ];
      
        // Imprimir los títulos y valores en dos columnas
        let startY = 50; // Y inicial
        labels.forEach((label, index) => {
          doc.setFont('helvetica', 'bold'); // Negrita para los títulos
          doc.text(label, 10, startY);
      
          doc.setFont('helvetica', 'normal'); // Normal para los valores
          doc.text(values[index], 60, startY);
      
          startY += 10; // Espacio entre filas
        });
      
        // Espacio antes del código de barras
        doc.text('Código de Barras Generado:', 10, startY + 10);
      
        // Añadir el código de barras generado al PDF
        const imgWidth = 100; // Ancho del código de barras
        const imgHeight = 50; // Alto del código de barras
        doc.addImage(barcodeImage, 'PNG', 55, startY + 20, imgWidth, imgHeight);
      
        // Descargar el PDF
        doc.save(`sku_info_${sku}.pdf`);
      
        alert('PDF generado con éxito');
      } else {
        throw new Error('El código de barras no es válido');
      }
      
  
    } catch (error) {
      // Manejar errores
      setError(error.message || 'Ocurrió un error al generar el PDF');
    } finally {
      setLoading(false);
    }
  };
  
  
  return (
    <div className="info-sku-container">
      <button className="adminproductos-back-button" onClick={() => navigate(`/init`)}>
        &#8592;
      </button>
      <h1 className="info-sku-title">Información de SKU</h1>

      <form onSubmit={handleSubmit} className="info-sku-form">
        <div className="form-group">
          <label htmlFor="quantity">Cantidad por pallet:</label>
          <input
            type="number"
            id="quantity"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            className="info-sku-input"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="sku">SKU:</label>
          <input
            type="number"
            id="sku"
            value={sku}
            onChange={(e) => setSku(e.target.value)}
            className="info-sku-input"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="expiryDate">Fecha de vencimiento:</label>
          <input
            type="date"
            id="expiryDate"
            value={expiryDate}
            onChange={(e) => setExpiryDate(e.target.value)}
            className="info-sku-input"
            required
          />
        </div>
        {error && <div className="info-sku-error">{error}</div>}
        <button type="submit" className="info-sku-submit-button" disabled={loading}>
          {loading ? 'Generando...' : 'Generar'}
        </button>
      </form>
    </div>
  );
};

export default InfoSku;
